import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CodeTypeModel } from '../definition/code-type.model';
import { GenericApiService } from 'shared/services';

@Injectable({
  providedIn: 'root'
})
export class CodeTypeService extends GenericApiService<CodeTypeModel,any> {

  constructor(injector: Injector) {
    super(injector, "CodeType");
  }
 
}